"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var Box_1 = __importDefault(require("@mui/material/Box"));
var react_redux_1 = require("react-redux");
var ButtonWithModal_1 = require("atomicComponents/organisms/Button/ButtonWithModal");
var TableMaker_1 = __importDefault(require("containers/TableMaker"));
var ordered_1 = require("utils/selectors/ordered");
var AddVendorModal_1 = __importDefault(require("./AddVendorModal"));
var tableConf_1 = __importDefault(require("./tableConf"));
var Table = (0, TableMaker_1.default)(tableConf_1.default);
var Vendors = function () {
    var newVendors = (0, react_redux_1.useSelector)(ordered_1.selectNewRechargedVendors);
    return ((0, jsx_runtime_1.jsx)(Table, { children: !!(newVendors === null || newVendors === void 0 ? void 0 : newVendors.length) && ((0, jsx_runtime_1.jsx)(Box_1.default, __assign({ width: 1, height: 1, overflow: "auto" }, { children: (0, jsx_runtime_1.jsx)(ButtonWithModal_1.LineBtnWithModal, __assign({ modalComponent: AddVendorModal_1.default, color: "neutral", size: "small" }, { children: "Add new vendor" })) }))) }));
};
exports.default = Vendors;
